import { SchedulerClinicalCoordinators, SchedulerClinicalCoordinatorPersonalView } from '@lp/features/Scheduler';
import { useAuthContext } from '@lp/core/auth';
import { SchedulerPermissions } from '@/permissions';

export const CCSchedule = () => {
  const { checkPermission } = useAuthContext();
  const readonly = !checkPermission(SchedulerPermissions.CCSchedulesWrite);
  const isPersonalView = checkPermission(SchedulerPermissions.CCMyScheduleWrite);

  return isPersonalView ? (
    <SchedulerClinicalCoordinatorPersonalView />
  ) : (
    <SchedulerClinicalCoordinators readonly={readonly} />
  );
};
